<div [hidden]="closeOverlay()" class="slide-over" [class]="class()">
  <div class="overlay" (click)="onClickOutside($event)" tabindex="0"></div>
  <div [@slideOver]="closeContent() ? 'closed' : 'open'" class="slide-content">
    <app-button (pressed)="onClickClose($event)" class="slide-button-close" type="icon">
      <mat-icon>close</mat-icon>
    </app-button>
    <ng-content></ng-content>
  </div>
</div>
